import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory, useParams } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip, TextField } from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
function ApprovalIndex() {
    const history = useHistory();
    const { id, tid } = useParams();
    const [data, setData] = useState([]);
    const { isAuthenticated, companyId, userId, permissions, logout, token } = useAuth();
    const [searchQuery, setSearchQuery] = useState(""); // State for search query
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {

        fetchtableData();

    }, []);

    const fetchtableData = async () => {

        fetchData('ReturnApprovalApi', `/${companyId}/${id}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching SaleReturn Details:', error);
            });

    };
    // Extract CustomerName and Route from the first item in the data array
    const customerName = data.length > 0 ? data[0].CustomerName : "";
    const route = data.length > 0 ? data[0].Route : "";
    const returnDate = data.length > 0 ? data[0].ReturnDate : "";
    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '90%' }}>

            <div className='w-full mb-2 flex'>
                <h5 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bold' }}> Approval Index</h5>
                {/* <Link to={`/SaleReturnApprovalIndex`}>
                    <Button style={{ background: '#FF004F', fontWeight: 'bolder', color: 'white' }} > <UndoIcon style={{ fontWeight: 'bolder' }} /> Cancel</Button>
                </Link> */}
                <Tooltip title="Exit">
                    <Link to={`/SaleReturnApprovalIndex`} style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                        <Button variant="contained" color="error" style={{ marginLeft: '10px', height: '30px' }}>
                            Back < ExitToAppIcon />
                        </Button>
                    </Link>
                </Tooltip>
                <br />

            </div>
            {customerName && route && returnDate && (
                <div className='w-full mb-2 flex'>
                    <h5 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#954535', fontWeight: 'bold', marginLeft: '10px' }}>
                        Customer : {customerName}
                    </h5>

                    <h5 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#954535', fontWeight: 'bold', marginLeft: '90px' }}>
                        Route : {route}
                    </h5>

                    <h5 className='productHead flex-grow linkcolor' style={{ marginLeft: '100px' }}>
                        <span style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#954535', fontWeight: 'bold' }}>
                            Return Date:
                        </span>
                        <span style={{ marginLeft: '5px', color: '#954535', fontWeight: 'bold' }}>
                            {returnDate && new Date(returnDate).toLocaleDateString('en-GB')}
                        </span>
                    </h5>
                </div>
            )}
            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto' }}>
                <TableContainer component={Paper} style={{ maxHeight: '500px' }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#008080' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px' }}>Item Name</TableCell>

                                <Tooltip title="Return Rate Per Piece">
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px', textAlign: 'right' }}>Rate <p style={{ fontSize: '11px', marginBlock: '-7px' }}> (per piece)</p></TableCell>
                                </Tooltip>
                                {/* <Tooltip title="Return Rate">
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px',textAlign:'right' }}>R.Rate</TableCell>
                                </Tooltip> */}
                                <Tooltip title="Return Quantity">
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px', textAlign: 'right' }}>R.Qty<p style={{ fontSize: '11px', marginBlock: '-7px' }}> (No.of pieces)</p></TableCell>
                                </Tooltip>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px', textAlign: 'right' }}>Taxable Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px', textAlign: 'right' }}>GST Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px', textAlign: 'right' }}>Total Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bold', fontSize: '16px', padding: '7px', width: '150px', textAlign: 'center' }}>Status</TableCell>

                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: 'white' }}>
                            {data.map(item => (
                                <TableRow key={item.Id} style={{ backgroundColor: item.IsApproved ? '#d4edda' : item.IsRejected ? '#f8d7da' : 'inherit' }}  >
                                    <TableCell style={{ borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px' }}>{item.ItemName}</TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', textAlign: 'right' }}>{(item.RateperKg).toFixed(2)}</TableCell>
                                    {/* <TableCell style={{ borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px' ,textAlign:'right'}}>{(item.RateperKg* item.Bagweight).toFixed(2)}</TableCell> */}
                                    <TableCell style={{ borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', textAlign: 'right' }}>{item.RQuantity}</TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', textAlign: 'right' }}>{item.TaxableAmount.toFixed(2)}</TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', textAlign: 'right' }}>{item.GST.toFixed(2)}</TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', textAlign: 'right' }}>{item.TotalAmount.toFixed(2)}</TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bold', padding: '5px', width: '25px', color: item.IsApproved ? 'green' : item.IsRejected ? 'red' : 'inherit', textAlign: 'center' }}>
                                        {item.IsApproved ? 'Approved' : item.IsRejected ? 'Rejected' : ''}
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                        {/* Delete confirmation dialog */}
                        <tfoot>
                            <tr >
                                <td className="border-r text-left text-sm " colSpan="1" style={{ backgroundColor: 'rgb(217 238 93)', fontWeight: 'bold', color: 'brown', fontSize: '17px' }}>Total</td>
                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(217 238 93)', fontWeight: 'bold', color: 'brown', fontSize: '17px' }}>{data.reduce((acc, item) => acc + item.RateperKg, 0).toFixed(2)}</td>
                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(217 238 93)', fontWeight: 'bold', color: 'brown', fontSize: '17px' }}>{data.reduce((acc, item) => acc + item.RQuantity, 0)}</td>
                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(217 238 93)', fontWeight: 'bold', color: 'brown', fontSize: '17px' }}>{data.reduce((acc, item) => acc + item.TaxableAmount, 0).toFixed(2)}</td>
                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(217 238 93)', fontWeight: 'bold', color: 'brown', fontSize: '17px' }}>{data.reduce((acc, item) => acc + item.GST, 0).toFixed(2)}</td>
                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(217 238 93)', fontWeight: 'bold', color: 'brown', fontSize: '17px' }}>{data.reduce((acc, item) => acc + item.TotalAmount, 0).toFixed(2)}</td>
                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(217 238 93)', fontWeight: 'bold', color: 'brown', fontSize: '17px' }}></td>
                            </tr>
                        </tfoot>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}
export default ApprovalIndex;

